var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-form",
        { on: { submit: _vm.addOrUpdateGroupRecord } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-4", attrs: { md: "9", sm: "12" } },
                [
                  _vm._.get(this.group, "id", false)
                    ? _c("h4", { staticClass: "card-title mb-0" }, [
                        _vm._v(_vm._s(this.group.groupName))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !this.group.id
                    ? _c("h4", { staticClass: "card-title mb-0" }, [
                        _vm._v("Update Group")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "small text-muted" }, [
                    _vm._v("Added " + _vm._s(_vm.getGroupAddedDate()))
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _vm.group.id
                    ? _c("GroupForm", { attrs: { group: _vm.group } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { attrs: { "align-h": "end" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "p-3", attrs: { cols: "auto" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "marginR-32",
                              attrs: {
                                variant: "secondary",
                                href: "/admin/groups/" + _vm.group.id
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.addOrUpdateGroupRecord }
                            },
                            [_vm._v("Submit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            dismissible: "",
            fade: "",
            show: _vm.groupEditFailure,
            variant: "danger"
          }
        },
        [_c("span", { domProps: { innerHTML: _vm._s(_vm.groupEditFailure) } })]
      ),
      _vm._v(" "),
      _c(
        "h2",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.editGroupPending,
              expression: "editGroupPending"
            }
          ],
          staticClass: "u-padding-bottom-20"
        },
        [_vm._v("Updating, please wait ...")]
      ),
      _vm._v(" "),
      _c("pulse-loader", {
        attrs: {
          loading: _vm.editGroupPending,
          color: _vm.spinnerColor,
          size: _vm.spinnerSize
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dda79c46", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dda79c46","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/EditGroup.vue
// module id = 1922
// module chunks = 0